const VoucherStatus = {
  Unclaimed: "unclaimed",
  Used: "used",
  Expired: "expired",
  AvailableInApp: "available-in-app",
  Void: "void",
  Available: "available",
  Claimed: "claimed",
  Ongoing: "ongoing",
};

export default VoucherStatus;
